import { MentorStoryReviewScreen } from "@/components/users/mentor-story-review-screen";
import { requirePermission } from "@/lib/casl/route-guards";
import { useMentorStoriesEnabled } from "@/lib/hooks/use-mentor-stories";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/users/mentor-story-reviews/$reviewId",
)({
  component: MentorStoryReviewRoute,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "mentor-profile-reviews");
  },
});

function MentorStoryReviewRoute() {
  const { reviewId } = Route.useParams();
  const storiesEnabled = useMentorStoriesEnabled();
  if (!storiesEnabled) return <Navigate to="/users" />;
  return <MentorStoryReviewScreen reviewId={reviewId} />;
}
